import { Color, Size } from '@components/Chip/Chip';

export const SIZE: Record<Size, string> = {
  small: '22px',
  medium: '26px',
  large: '30px',
};

export const COLOR: Record<Color, Record<string, string>> = {
  default: {
    dark: '#000000',
    main: '#00000087',
    background: '#00000004',
    hover: '#00000012',
  },
  primary: {
    dark: '#006562',
    main: '#0C938F',
    background: '#0C938F04',
    hover: '#0C938F12',
  },
  secondary: {
    dark: '#67075A',
    main: '#8E2880',
    background: '#8E288004',
    hover: '#8E288012',
  },
  error: {
    dark: '#C62828',
    main: '#D32F2F',
    background: '#D32F2F04',
    hover: '#D32F2F12',
  },
  warning: {
    dark: '#E65100',
    main: '#ED6C02',
    background: '#ED6C0204',
    hover: '#ED6C0212',
  },
  info: {
    dark: '#01579B',
    main: '#0288D1',
    background: '#0288D104',
    hover: '#0288D112',
  },
  success: {
    dark: '#1B5E20',
    main: '#2E7D32',
    background: '#2E7D3204',
    hover: '#2E7D3212',
  },
  disabled: {
    dark: 'rgba(0, 0, 0, 0.87)',
    main: '#00000038',
    background: '#00000004',
    hover: '#00000012',
  },
};
